import type { ReactNode } from "react";
import { hasPerm } from "../lib/permissions";

/**
 * กันจอที่ต้องมีสิทธิ์รหัสใดรหัสหนึ่ง (ADR-0030) — เป็นแค่การนำทาง server ตอบ 403 อีกชั้นเสมอ
 * คนที่สิทธิ์ไม่ถึงควรเจอคำอธิบายภาษาลาว ไม่ใช่จอที่ยิง 403 รัว ๆ
 */
export function RequirePerm({
  perm,
  children,
  message,
  hint,
}: {
  perm: string | readonly string[];
  children: ReactNode;
  message: string;
  hint?: string;
}) {
  if (hasPerm(perm)) return <>{children}</>;
  return (
    <div className="access-denied stack">
      <h1 className="page-title">ສິດບໍ່ພຽງພໍ</h1>
      <p className="body-sm">{message}</p>
      {hint ? <p className="caption">{hint}</p> : null}
    </div>
  );
}
